(function () {
  if (window.ntCutoffInit) {
    if (typeof window.ntCutoffPaint === 'function') window.ntCutoffPaint();
    return;
  }
  window.ntCutoffInit = true;

  var weekdayIndex = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  var istanbul = function (date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Istanbul',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var out = { weekday: 0, hour: 0, minute: 0 };
    parts.forEach(function (part) {
      if (part.type === 'weekday') out.weekday = weekdayIndex[part.value] || 0;
      if (part.type === 'hour') out.hour = parseInt(part.value, 10) % 24;
      if (part.type === 'minute') out.minute = parseInt(part.value, 10) || 0;
    });
    return out;
  };

  var fill = function (template, map) {
    return (template || '').replace(/\|\|(\w+)\|\|/g, function (_, key) {
      return map[key] != null ? map[key] : '';
    });
  };

  // data-rich düğümlerde değişkenler (saat, dakika, gün) <strong> ile vurgulanır; metin DOM ile kurulur, innerHTML kullanılmaz.
  var fillRich = function (node, template, map) {
    var source = template || '';
    var pattern = /\|\|(\w+)\|\|/g;
    var last = 0;
    var match;
    node.textContent = '';
    while ((match = pattern.exec(source)) !== null) {
      if (match.index > last) node.appendChild(document.createTextNode(source.slice(last, match.index)));
      var value = map[match[1]] != null ? String(map[match[1]]) : '';
      if (value) {
        var strong = document.createElement('strong');
        strong.textContent = value;
        node.appendChild(strong);
      }
      last = pattern.lastIndex;
    }
    if (last < source.length) node.appendChild(document.createTextNode(source.slice(last)));
  };

  var pad = function (value) {
    return String(value).padStart(2, '0');
  };

  var dayName = function (days, weekday) {
    var index = weekday === 0 ? 6 : weekday - 1;
    return days[index] || '';
  };

  // Kargo çıkış günleri: Pzt–Cum (ayar açıksa Cumartesi de). Kargo günü kesim saatinden önce → aynı gün.
  // Kesimden sonra veya kargo çıkışı olmayan günde → bir sonraki kargo günü (yarınsa "yarın", değilse gün adı).
  var isShipDay = function (weekday, saturday) {
    return (weekday >= 1 && weekday <= 5) || (saturday && weekday === 6);
  };

  var nextShipOffset = function (weekday, saturday) {
    for (var offset = 1; offset <= 7; offset++) {
      if (isShipDay((weekday + offset) % 7, saturday)) return offset;
    }
    return 1;
  };

  // "5 saat", "5 saat 30 dakika", "40 dakika" — sıfır olan birim yazılmaz.
  var formatTime = function (hours, minutes, unitHour, unitMinute) {
    var parts = [];
    if (hours > 0) parts.push(hours + ' ' + unitHour);
    if (minutes > 0 || hours === 0) parts.push(minutes + ' ' + unitMinute);
    return parts.join(' ');
  };

  var messageFor = function (now, cutHour, days, templates) {
    var saturday = !!templates.saturday;
    var cutoff = pad(cutHour) + ':00';
    var nowMinutes = now.hour * 60 + now.minute;
    var shipToday = isShipDay(now.weekday, saturday);
    var before = shipToday && nowMinutes < cutHour * 60;
    var map = { hours: 0, minutes: 0, time: '', cutoff: cutoff, day: '' };
    var template;

    if (before) {
      var left = cutHour * 60 - nowMinutes;
      map.hours = Math.floor(left / 60);
      map.minutes = left % 60;
      map.time = formatTime(map.hours, map.minutes, templates.unitHour || 'saat', templates.unitMinute || 'dakika');
      map.day = templates.today || dayName(days, now.weekday);
      template = map.hours > 0 ? templates.same : templates.sameMin;
    } else {
      var offset = nextShipOffset(now.weekday, saturday);
      // "yarın" yalnızca kargo günü kesimden sonra; kargo çıkışı olmayan günlerde her zaman gün adı (örn. "Pazartesi günü").
      var suffix = templates.daySuffix ? ' ' + templates.daySuffix : '';
      map.day = offset === 1 && shipToday && templates.tomorrow
        ? templates.tomorrow
        : dayName(days, (now.weekday + offset) % 7) + suffix;
      template = shipToday ? templates.next : (templates.closed || templates.next);
    }

    // same: kargo günü + kesimden önce (aynı gün kargo) · next: kargo günü, kesim geçti · closed: kargo çıkışı olmayan gün
    var state = before ? 'same' : (shipToday ? 'next' : 'closed');

    return {
      day: map.day,
      countdown: before,
      state: state,
      hours: map.hours,
      minutes: map.minutes,
      template: template,
      map: map,
      text: fill(template, map)
    };
  };

  window.ntCutoffMessage = function (date, cutHour, daysCsv, templates) {
    var hour = parseInt(cutHour, 10);
    if (isNaN(hour)) hour = 15;
    var days = (daysCsv || '').split(',').map(function (day) { return day.trim(); });
    return messageFor(istanbul(date), hour, days, templates || {});
  };

  var paintNode = function (node, now) {
    var cutHour = parseInt(node.getAttribute('data-hour'), 10);
    if (isNaN(cutHour)) cutHour = 15;
    var days = (node.getAttribute('data-days') || '').split(',').map(function (day) { return day.trim(); });
    // Tek satır kartında kısa mesajlar (data-line-*) doluysa onlar kullanılır, boşsa uzun mesaja düşülür.
    var pick = function (name) {
      return node.getAttribute('data-line-' + name) || node.getAttribute('data-' + name);
    };
    var result = messageFor(now, cutHour, days, {
      same: pick('same'),
      sameMin: pick('same-min'),
      next: pick('next'),
      closed: pick('closed'),
      today: node.getAttribute('data-today'),
      tomorrow: node.getAttribute('data-tomorrow'),
      saturday: node.getAttribute('data-saturday') === 'true',
      daySuffix: node.getAttribute('data-day-suffix'),
      unitHour: node.getAttribute('data-unit-hour'),
      unitMinute: node.getAttribute('data-unit-minute')
    });
    if (node.hasAttribute('data-rich')) {
      fillRich(node, result.template, result.map);
    } else {
      node.textContent = result.text;
    }
    var card = node.closest('[data-nt-cutoff-card]');
    if (card) {
      card.hidden = !result.text;
      card.classList.toggle('is-countdown', result.countdown);
      // Başlık mesajla çelişmesin: "Aynı gün kargo" yalnızca aynı gün kargo mümkünken görünür.
      var title = card.querySelector('[data-nt-cutoff-title]');
      if (title) {
        var titleText = card.getAttribute('data-title-' + result.state) || '';
        if (title.textContent !== titleText) title.textContent = titleText;
        title.hidden = !titleText;
      }
      card.classList.add('is-ready');
      // Tek satırda sığmayan mesajın tamamı üzerine gelince okunabilsin.
      if (card.classList.contains('nt-cutoff-card--line')) {
        node.setAttribute('title', result.text);
        fitLine(card);
      }
    }
  };

  // Tek satır kartı: sığmıyorsa önce yazı biraz küçültülür (en az 11.5px), yine sığmazsa başlık gizlenir
  // ve mesaj tek başına sığdırılır (en az 10.5px). En son çare olarak CSS "…" ile keser.
  var shrink = function (body, text, min) {
    body.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(body).fontSize) || 13;
    var guard = 0;
    while (text.scrollWidth > text.clientWidth && size > min && guard < 12) {
      size -= 0.5;
      body.style.fontSize = size + 'px';
      guard++;
    }
    return text.scrollWidth <= text.clientWidth;
  };

  var fitLine = function (card) {
    var body = card.querySelector('.nt-cutoff-card__body');
    var text = card.querySelector('.nt-cutoff-card__text');
    if (!body || !text) return;
    card.classList.remove('is-compact');
    if (!body.clientWidth) return;
    if (shrink(body, text, 11.5)) return;
    var title = card.querySelector('.nt-cutoff-card__title');
    if (title && title.offsetWidth) card.classList.add('is-compact');
    shrink(body, text, 10.5);
  };

  var refit = function () {
    document.querySelectorAll('.nt-cutoff-card--line.is-ready').forEach(fitLine);
  };
  var refitTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(refitTimer);
    refitTimer = window.setTimeout(refit, 150);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);

  var paint = function () {
    var nodes = document.querySelectorAll('[data-nt-cutoff]');
    if (!nodes.length) return;
    var now = istanbul(new Date());
    nodes.forEach(function (node) {
      paintNode(node, now);
    });
  };

  window.ntCutoffPaint = paint;
  paint();
  window.setInterval(paint, 30000);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var added = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          if ((node.matches && node.matches('[data-nt-cutoff]')) || (node.querySelector && node.querySelector('[data-nt-cutoff]'))) {
            added = true;
          }
        });
      });
      if (added) paint();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
